module.exports = `<svg data-id="SVG_TOOLTIP_INFO__16" style="color: #0067DB;" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" fill="currentColor" fill-rule="evenodd"><path stroke="none" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0z">
        
    </path>
    <path strok="none" d="M9 13V7.3H7V13zM8 5.7c.7 0 1.3-.6 1.3-1.4C9.3 3.6 8.7 3 8 3c-.7 0-1.3.6-1.3 1.3 0 .8.6 1.4 1.3 1.4z" fill="#FFF">
        
    </path></g>
</svg>`;
